import { registerPalette } from 'devextreme/viz/palette';

export function emptyFunction() {}
export function emptyReturnFunction() {
    return '';
}
export function emptyListFunction() {
    return {};
}
export function emptyArrayFunction() {
    return [];
}

export function devExpressAddCustomPalette(): boolean {
    const myPalette = {
        simpleSet: ['#527fbb', '#5b8dd0', '#649be4', '#72a4e6', '#80ade8', '#8eb6eb', '#9cbfed', '#aac8f0'], // for "Chart", "PieChart" and "BarGauge"
        indicatingSet: ['#649be4', '#d4e3f7', '#527fbb', '#9cbfed', '#406392', '#80ade8', '#2e4768'], // for "CircularGauge" and "LinearGauge"
        gradientSet: ['#649be4', '#527fbb'] // for "VectorMap"
    };
    registerPalette('Monochrome Blue', myPalette);
    return true;
}

//LL: ColorHexWrapper - covert Color <=> Hex
export class ColorHexWrapper {
    //  http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb

    private static componentToHex(c) {
        // 'c' - numeric ~~ 5e
        const hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    public static rgbToHex(r, g, b) {
        // r, g, b - numeric ~~ 5e
        return (
            '#' +
            ColorHexWrapper.componentToHex(r) +
            ColorHexWrapper.componentToHex(g) +
            ColorHexWrapper.componentToHex(b)
        );
    }

    public static hexToRgb(hex) {
        // 'hex' - "#0033ff"
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result
            ? {
                  r: parseInt(result[1], 16),
                  g: parseInt(result[2], 16),
                  b: parseInt(result[3], 16)
              }
            : null;
    }

    public static indexToColor(index) {
        // Угол в цветовом круге (шаг 137.5° ~ золотое сечение * 360° для равномерного распределения)
        const hue = (index * 137.5) % 360;
        // Насыщенность и яркость фиксированы для контраста
        const saturation = 50; //90 + (index % 10); // Небольшие вариации
        const lightness = 50; //80 + (index % 5);   // Легкие колебания яркости

        // Преобразуем HSL в RGB
        return ColorHexWrapper.hslToRgb(hue, saturation, lightness);
    }

    // Вспомогательная функция: HSL → RGB
    public static hslToRgb(h, s, l) {
        h /= 360;
        s /= 100;
        l /= 100;

        let r, g, b;
        if (s === 0) {
            r = g = b = l;
        } else {
            const hue2rgb = (p, q, t) => {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            };
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return ColorHexWrapper.rgbToHex(Math.round(r * 255), Math.round(g * 255), Math.round(b * 255));
    }
}
